import { render, staticRenderFns } from "./pbcList.vue?vue&type=template&id=3d5bb72b&scoped=true"
import script from "./pbcList.vue?vue&type=script&lang=js"
export * from "./pbcList.vue?vue&type=script&lang=js"
import style0 from "./pbcList.vue?vue&type=style&index=0&id=3d5bb72b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5bb72b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d5bb72b')) {
      api.createRecord('3d5bb72b', component.options)
    } else {
      api.reload('3d5bb72b', component.options)
    }
    module.hot.accept("./pbcList.vue?vue&type=template&id=3d5bb72b&scoped=true", function () {
      api.rerender('3d5bb72b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/toNextYear/pbcList.vue"
export default component.exports